module.exports = __webpack_public_path__ + "static/img/page02.ff396a0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/page02.jpg
// module id = cmGd
// module chunks = 0